<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Form type
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.type.options" v-model="element.object.values.type" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Disable service type selection
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.values.disable_service_type"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Pioneer selection
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.values.pioneer"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Locations
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            All
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="fields.locations.options[0].checked"
                        />
                    </div>
                </div>

                <div v-if="fields.locations.options.length > 0 && !fields.locations.options[0].checked">
                    <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);" v-for="(location, index) in fields.locations.options" v-if="location.name != 'All'">
                        <div class="w-1/2">
                            <label class="text-xs text-grey-darker">
                                {{ location.name }}
                            </label>
                        </div>
                        <div class="w-1/2 text-right">
                            <app-toggle-field
                                :required="false"
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                v-model="fields.locations.options[index].checked"
                            />
                        </div>
                    </div>
                </div>

                <!-- <div v-if="loading" class="flex items-center justify-center py-12">
                    <loader />
                </div>
                <div v-else>
                    <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                        Properties
                    </div>
                    <app-field-select default-field="cmp-default-field" :field="fields.form" v-model="element.object.values.form" />
                </div> -->
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';

    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import SelectField from '@/components/fields/inputs/Select';
    import ToggleField from '@/components/fields/inputs/Toggle';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-select': SelectField,
            'app-toggle-field': ToggleField,
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            loading: true,
            forms: [],
            fields: {
                form: {
                    name: 'Form',
                    attribute: 'form',
                    options: []
                },
                pioneer: {
                    name: 'Enable pioneer',
                    attribute: 'pioneer'
                },
                disable_service_type: {
                    name: 'Enable service type',
                    attribute: 'disable_service_type',
                },
                type: {
                    name: 'Form type',
                    attribute: 'type',
                    options: [
                        {
                            value: 'ask-a-question',
                            label: 'Ask a Question'
                        },
                        {
                            value: 'booking',
                            label: 'Booking'
                        },
                        {
                            value: 'contact-form',
                            label: 'Contact'
                        },
                        {
                            value: 'contact-form-minimal',
                            label: 'Contact form minimal'
                        },
                        {
                            value: 'franchise',
                            label: 'Franchise'
                        },
                        {
                            value: 'gdpr',
                            label: 'GDPR'
                        },
                        {
                            value: 'request-a-callback',
                            label: 'Request a callback'
                        },
                        {
                            value: 'crm-additional-mot-reminder',
                            label: 'CRM - additional MOT reminder'
                        },
                        {
                            value: 'crm-mot-reminder-opt-out',
                            label: 'CRM - MOT reminder opt out'
                        },
                        {
                            value: 'friends-and-family',
                            label: 'Friends and family'
                        }
                    ]
                },
                locations: {
                    name: 'Location',
                    attribute: 'location',
                    options: [
                        {
                            id: 0,
                            name: 'All',
                            slug: 'all',
                            checked: true
                        },
                    ]
                },
            }
        }),

        created() {
            // Get all locations
            return Api.request('get', `locations/locations?filterForWebsite=true`)
                .then(({ data }) => {
                    this.fields.locations.options[ 0 ].checked = typeof this.element.object.values.locations[ 0 ] !== 'undefined' ? this.element.object.values.locations[ 0 ].checked : this.fields.locations.options[ 0 ].checked;

                    data.locations.forEach((location, index) => {

                        // Add in checked state
                        location['checked'] = this.element.object.values.locations.filter( ( elLocation ) => {
                            return elLocation.id === location.id && elLocation.checked === true;
                        } ).length;
                        // Push to options array so to not overwrite 'All' option
                        this.fields.locations.options.push(location);
                    });
                });
        },

        mounted() {
            // this.getForms().then(response => {
            //     this.loading = false;
            // });
        },

        computed: {
            shiftedLocations: function () {
                return this.fields.locations.options.filter( ( location, index ) => {
                    return index > 0;
                } );
            }
        },

        watch: {
            'fields.locations.options': {
                deep: true,
                handler: function( value ) {
                    this.element.object.values.locations = value;
                }
            }
        },

        methods: {
            getForms() {
                this.forms = [];
                this.fields.form.options = [];

                return Admin.request().get('/admin-api/composer/forms')
                    .then(({ data }) => {
                        this.forms = data.forms;

                        this.setFormsFields();
                    });
            },

            setFormsFields() {
                this.fields.form.options.push({
                    value: false,
                    label: 'None'
                });

                if (this.forms.length > 0) {
                    for (let i in this.forms) {
                        this.fields.form.options.push({
                            value: this.forms[i].handle,
                            label: this.forms[i].name
                        });
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/FormSettings.vue